import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {Servicio} from "./servicio";
import { User } from '../modelo/usuario';
import {Persona} from '../modelo/persona';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router,ActivatedRoute } from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';
import Swal from 'sweetalert2';
@Injectable({ providedIn: 'root' })
export class AuthenticationService {
    private currentUserSubject: BehaviorSubject<Persona>;
    public currentUser: Observable<Persona>;

    constructor(
        public snackBar:MatSnackBar,
        private ngxService: NgxUiLoaderService,
        public servicio:Servicio,
        private http: HttpClient,public router:Router) {
            //alert(localStorage.getItem('currentUser'));
        this.currentUserSubject = new BehaviorSubject<Persona>(JSON.parse(sessionStorage.getItem('currentUser')));
        this.currentUser = this.currentUserSubject.asObservable();
    }

    public get currentUserValue(): Persona {
        return this.currentUserSubject.value;
    }

    login(username: string, password: string,_snackBar) {
        return this.http.post<any>(this.servicio.url_global+'/Login/iniciar_sesion_web', { username, password })
            .pipe(map(user => {
                // login successful if there's a jwt token in the response

                if (user && user.token) {

                    sessionStorage.setItem('currentUser', JSON.stringify(user));
                    this.currentUserSubject.next(user);
                }else
                {

                   _snackBar.open(user["MSG"],"",{
                    duration: 2000,
                  })
                }

                return user;
            }));
    }

    iniciar_sesion(json={},checkoutForm){
       var _this=this;
        this.ngxService.start();
        this.servicio.enviar_seguro("api/ws_socioenlinealogin_web",json,sessionStorage["token"]).pipe().subscribe(
            response=>{



                 if(response["status"]=="200"){
                   var body=response["response"];

                     if(body[0]["rpt"]==1){


                     // console.log(json);
                          sessionStorage.setItem('currentUser', JSON.stringify(
                            new Persona(
                              body[0]["apellidos"],
                            body[0]["nombre"],
                            body[0]["fechaVenceFPS"],
                            body[0]["cuenta"],
                          response["token"],
                          body[0]["docIdentidad"],
                          json["documento"],
                          body[0]["codigoAgencia"],
                          body[0]["email"],
                          body[0]["numeroCelular"],
                          body[0]["montoMaximoMN"],
                          body[0]["montoMaximoME"],
                          body[0]["fechaPagoFPS"]
                          ,body[0]["requiereCambioClave"]
                          )));
                          this.currentUserSubject.next(  new Persona(
                            body[0]["apellidos"],
                          body[0]["nombre"],
                          body[0]["fechaVenceFPS"],
                          body[0]["cuenta"],
                        response["token"],
                        body[0]["docIdentidad"],
                        json["documento"],
                        body[0]["codigoAgencia"],
                        body[0]["email"],
                        body[0]["numeroCelular"],
                        body[0]["montoMaximoMN"],
                        body[0]["montoMaximoME"],
                        body[0]["fechaPagoFPS"],
                        body[0]["requiereCambioClave"]
                        ));
                         this.router.navigate(['/inicio']);


                     }else{

                        //console.log(".......dlkaskdañlkdsak");
                        checkoutForm.controls['clave'].setValue('');

                        //console.log(valor_clave);
                        if(body[0]["bloqueado"].toString()=="1")
                        {
                          Swal.fire(
                            'ERROR!',
                            "Su cuenta se bloqueo por seguridad intente dentro de una hora",
                            'error'
                          ).then((result) => {

                          });
                        }else{
                          _this.snackBar.open("Los datos son incorrectos, por favor vuelva a intentar. Se bloqueará en el quinto intento","",{
                            duration: 2000,
                          })

                        }

                     }
                    this.ngxService.stop();

                 }else{

                   this.ngxService.stop();

                 }




            }  ,
              error => {
                 // this.alertService.error(error);
                 //this.emitComplete();

              }
          );

    }


    iniciar_sesion_voto(json={},checkoutForm){
      var _this=this;
       this.ngxService.start();
       this.servicio.enviar_seguro("api/ws_login_voto_nuevo",json,sessionStorage["token"]).pipe().subscribe(
           response=>{



                if(response["status"]=="200"){
                  var body=response["response"];

                    if(body[0]["rpt"]==1){


                    // console.log(json);
                         sessionStorage.setItem('currentUser', JSON.stringify(
                           new Persona(
                             body[0]["apellidos"],
                           body[0]["nombre"],
                           body[0]["fechaVenceFPS"],
                           body[0]["cuenta"],
                         response["token"],
                         body[0]["docIdentidad"],
                         body[0]["documento"],
                         body[0]["codigoAgencia"],
                         body[0]["email"],
                         body[0]["numeroCelular"],
                         body[0]["montoMaximoMN"],
                         body[0]["montoMaximoME"],
                         body[0]["fechaPagoFPS"]
                         ,body[0]["requiereCambioClave"],
                         1
                         )));
                         this.currentUserSubject.next(  new Persona(
                           body[0]["apellidos"],
                         body[0]["nombre"],
                         body[0]["fechaVenceFPS"],
                         body[0]["cuenta"],
                       response["token"],
                       body[0]["docIdentidad"],
                       body[0]["documento"],
                       body[0]["codigoAgencia"],
                       body[0]["email"],
                       body[0]["numeroCelular"],
                       body[0]["montoMaximoMN"],
                       body[0]["montoMaximoME"],
                       body[0]["fechaPagoFPS"],
                       body[0]["requiereCambioClave"],1
                       ));
                        this.router.navigate(['/inicio/voto']);

                    }else{
                       //console.log(".......dlkaskdañlkdsak");
                       checkoutForm.controls['clave'].setValue('');
                       //console.log(valor_clave);
                       if(body[0]["bloqueado"].toString()=="1")
                       {
                         Swal.fire(
                           'ERROR!',
                           "Su cuenta se bloqueo por seguridad intente dentro de una hora",
                           'error'
                         ).then((result) => {

                         });
                       }else{
                         _this.snackBar.open(body[0]["msg"],"",{
                           duration: 4000,
                         })

                       }

                    }
                   this.ngxService.stop();

                }else{

                  this.ngxService.stop();

                }




           }  ,
             error => {
                // this.alertService.error(error);
                //this.emitComplete();

             }
         );

   }

    logout() {
        // remove user from local storage to log user out
        sessionStorage.removeItem('currentUser');
        this.currentUserSubject.next(null);
    }
}
